import { ModalProvider } from "@commonlibs";
import { BrowserRouter, useRoutes } from "react-router-dom";
import { config } from "common/config";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { useAuthRoutes } from "ui/auth/router/AuthRouter";
import LoadingPage from "ui/common/pages/LoadingPage/LoadingPage";
import { Suspense } from "react";
import NotFoundPage from "ui/common/pages/NotFoundPage/NotFoundPage";
import { useMainRoutes } from "ui/common/router/MainRouter";
import WidthLimiterLayout from "ui/common/components/layout/WidthLimiterLayout/WidthLimiterLayout";
import { useLoad } from "ui/common/hooks/useLoad";
import { useTermsAndConditionRoutes } from "ui/common/router/TermsAndConditionRouter";
import { useHelpRoutes } from "ui/common/router/HelpRouter";

const Routes = () => {
    const authRoutes = useAuthRoutes();
    const mainRoutes = useMainRoutes();
    const termsAndConditionsRoutes = useTermsAndConditionRoutes();
    const helpRoutes = useHelpRoutes();

    return useRoutes([...authRoutes, ...mainRoutes, ...termsAndConditionsRoutes, ...helpRoutes, { path: "*", element: <NotFoundPage /> }]);
};

const Router = (): JSX.Element => {
    const loading = useLoad();
    return (
        <BrowserRouter basename={config.publicUrl}>
            <ModalProvider>
                <ScrollToTop />
                <Suspense fallback={<LoadingPage />}>
                    <WidthLimiterLayout>{loading ? <LoadingPage /> : <Routes />}</WidthLimiterLayout>
                </Suspense>
            </ModalProvider>
        </BrowserRouter>
    );
};

export default Router;
